var map = {
	"./banbenshezhi.svg": "0805",
	"./directoryMaintenance.svg": "ebe6",
	"./revitBanbenshezhi.svg": "7cf2",
	"./rolePermission.svg": "6c95",
	"./yangbanshezhi.svg": "f7394"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c9c";